import styled from 'styled-components';
import { Content } from '@wearehelpful/ui-kit';

export const ScrollContainer = styled(Content.Fixed)`
  display: flex;
  flex-direction: column-reverse;
  overflow: auto;
  scroll-behavior: smooth;
  height: 100%;
  max-height: 100%;
`;

export const MessagesContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const Title = styled('span')`
  font-weight: 500;
  display: block;
  margin-top: 1px;
`;
